/// <reference path="../_references.ts"/>

module App.Administrative.Reviews {
	export type RequestReviewResponse = {
		status: string;
		message: string;
	}

	export type RequestReviewData = {
		service_request: number;
		email?: string;
		phone?: string;
	}
}